import React from 'react';
import {
    StylesProvider,
    Theme,
    ThemeProvider as MUIThemeProvider,
    CssBaseline,
} from '@material-ui/core';
import { ThemeProvider, createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    width: 'auto';
    overflow-x: hidden;
    font-size: '16px';
  };
  body {
    width: 'auto';
    overflow-x: hidden;
  }
`;

type Props = React.PropsWithChildren<{
    theme: Theme;
}>;

const ThemeProviders = ({ theme, children }: Props) => (
    <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
            <MUIThemeProvider theme={theme}>
                <GlobalStyle />
                <CssBaseline />
                {children}
            </MUIThemeProvider>
        </ThemeProvider>
    </StylesProvider>
);

export default ThemeProviders;
